import baixa from './baixa'
import balancete from './balancete'
import dispensacaoMateriais from './dispensacaoMateriais'
import entrada from './entrada'
import entradaInicial from './entradaInicial'
import inventario from './inventario'
import motivoBaixa from './motivoBaixa'
import parametrizacao from './parametrizacao'
import relatorioConsumoFinanceiro from './relatorioConsumoFinanceiro'
import relatorioConsumoMedioMensal from './relatorioConsumoMedioMensal'
import relatorioEntrada from './relatorioEntrada'
import relatorioEstornoEntrada from './relatorioEstornoEntrada'
import relatorioEstornoSaida from './relatorioEstornoSaida'
import relatorioMovimentacaoGeral from './relatorioMovimentacaoGeral'
import relatorioPosicaoEstoque from './relatorioPosicaoEstoque'
import relatorioRequisicao from './relatorioRequisicao'
import relatorioSaida from './relatorioSaida'
import relatorioValidadeMaterial from './relatorioValidadeMaterial'
import requisicaoAberturaFechamento from './requisicaoAberturaFechamento'
import requisicaoPendentePermissao from './requisicaoPendentePermissao'
import saida from './saida'
import transferencia from './transferencia'

export default [
    {
        path: 'almoxarifado',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...baixa,
            ...balancete,
            ...dispensacaoMateriais,
            ...entrada,
            ...entradaInicial,
            ...inventario,
            ...motivoBaixa,
            ...parametrizacao,
            ...relatorioConsumoFinanceiro,
            ...relatorioConsumoMedioMensal,
            ...relatorioEntrada,
            ...relatorioEstornoEntrada,
            ...relatorioEstornoSaida,
            ...relatorioMovimentacaoGeral,
            ...relatorioPosicaoEstoque,
            ...relatorioRequisicao,
            ...relatorioSaida,
            ...relatorioValidadeMaterial,
            ...requisicaoAberturaFechamento,
            ...requisicaoPendentePermissao,
            ...saida,
            ...transferencia,
        ]
    }
]